import React from 'react';
import { clsx } from 'clsx';
import styles from './TextInputWrapper.module.css.js';
import { BoxWithFallback } from './BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const TextInputBaseWrapper = /*#__PURE__*/React.forwardRef(function TextInputBaseWrapper({
  className,
  style,
  variant,
  size,
  isInputFocused,
  hasTrailingAction,
  validationStatus,
  disabled,
  contrast,
  monospace,
  block,
  width,
  minWidth,
  maxWidth,
  ...restProps
}, forwardRef) {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: "span",
    ref: forwardRef,
    className: clsx(className, styles.TextInputBaseWrapper),
    "data-block": block || undefined,
    "data-contrast": contrast || undefined,
    "data-disabled": disabled || undefined,
    "data-focused": isInputFocused || undefined,
    "data-monospace": monospace || undefined,
    "data-size": size || undefined,
    "data-trailing-action": hasTrailingAction || undefined,
    "data-validation": validationStatus || undefined,
    "data-variant": variant || undefined,
    style: typeof width === 'string' || typeof minWidth === 'string' || typeof maxWidth === 'string' ? {
      width,
      maxWidth,
      minWidth,
      ...style
    } : style,
    ...restProps
  });
});
TextInputBaseWrapper.displayName = 'TextInputBaseWrapper';
const TextInputWrapper = /*#__PURE__*/React.forwardRef(function TextInputWrapper({
  className,
  hasLeadingVisual,
  hasTrailingVisual,
  ...restProps
}, forwardRef) {
  return /*#__PURE__*/jsx(TextInputBaseWrapper, {
    ref: forwardRef,
    className: clsx(className, styles.TextInputWrapper),
    "data-leading-visual": hasLeadingVisual || undefined,
    "data-trailing-visual": hasTrailingVisual || undefined,
    ...restProps
  });
});

export { TextInputBaseWrapper, TextInputWrapper, TextInputWrapper as default };
